import { ISale, IFutureSale } from "shared/interfaces";

export const filterSalesBySearch = <T extends ISale | IFutureSale>(
  searchedSales: Array<T>,
  searchLowerCase: string
): Array<T> => searchedSales.filter((sale) => sale.metadata.name.toLowerCase().includes(searchLowerCase));
